import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderTagBase } from '@pages/page-tag-base/header-tagbase';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-tagbase',
    templateUrl: './form-tagbase.component.html',
    styleUrls: ['./form-tagbase.component.scss'],
    providers: [AutofocusDirective],
})
export class FormTagBaseComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;

    @Input()
    public dataItem: HeaderTagBase = null;

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            desc: null,
        });
        this.initialization();
    }

    ngOnInit() {
        if (this.dataItem !== null && this.dataItem !== undefined) {
            this.dataItem.notifyParent.subscribe(success => {
                this.resultForm.patchValue(this.dataItem);
            })
        }
    }

    ngOnDestroy() {
        if (this.dataItem !== null && this.dataItem !== undefined) {        
            this.dataItem.notifyParent.unsubscribe();
        }
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            data: this.resultForm.value,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.keys = {
            name: {
                label: this.translate.instant('Tag_Name'),
                pattern: '',
            },
            label: {
                label: this.translate.instant('Tag_Lab'),
                pattern: '',
            },
        };
    }
}
